import React, {
	createContext,
	useContext,
	useEffect,
	useReducer,
	useRef,
	useState,
} from 'react'
import { RouterProps, useNavigate, useParams, Link } from 'react-router-dom'
import logo from '../logo.svg'
import './FindInApp.scss'
import { Helmet } from 'react-helmet-async'
import SideMenu from '../components/SideMenu'
import store, {
	RootState,
	AppDispatch,
	useAppDispatch,
	notesSlice,
	methods,
	reducer,
} from '../store'
import { useSelector, useDispatch } from 'react-redux'
import { bindEvent } from '../modules/bindEvent'
import { useTranslation } from 'react-i18next'
import { snackbar, prompt, alert, progressBar } from '@saki-ui/core'
import { AES, Debounce, images } from '@nyanyajs/utils'

import { Header } from '../components'
import { api } from '../modules/electron/api'
import * as http from '../modules/http/api'
import { CategoryItem, NoteItem, PageItem } from '../store/notes/typings'
import { ReaderRouterProps } from '../modules/renderRoutes'
import { resolve } from 'path'
import { rejects } from 'assert'
import { SyncOff } from './Icon'
import { configSlice, initialConfigState, R, saass } from '../store/config'
import { IContext } from '../store'
import { log } from 'console'
import { decryptContent, encryptContent, Query } from '../modules/methods'
import { protoRoot } from '../protos'
import { pid } from 'process'
import {
	getImportanceColor,
	getSubTodoIds,
	getTodoList,
} from '../store/notes/todolist'
import moment from 'moment'
import { ContentResult, getContent } from '../store/notes/methods'

import { ImportanceDropdownComponent } from './TodoListContentPage'
import { click } from '@testing-library/user-event/dist/click'
import { catalogSlice, getCatalogEl } from '../store/catalog'
import {
	SakiAsideModal,
	SakiButton,
	SakiIcon,
	SakiInput,
	SakiScrollView,
	SakiTitle,
} from './saki-ui-react/components'

const FindInAppModal = () => {
	const { t, i18n } = useTranslation('findInAppModal')
	const dispatch = useDispatch<AppDispatch>()
	const notes = useSelector((state: RootState) => state.notes)
	const config = useSelector((state: RootState) => state.config)

	const findInAppModal = useSelector(
		(state: RootState) => state.config.pageConfig.findInAppModal
	)

	let history = useNavigate()

	const [searchKeyword, setSearchKeyword] = useState('')
	const [result, setResult] = useState<
		{
			note?: protoRoot.note.INoteItem
			category?: protoRoot.note.ICategoryItem
			page?: protoRoot.note.IPageItem
			pageContent?: string
			startIndex?: number
			endIndex?: number
			type: 'Note' | 'Category' | 'Page' | 'TodoList'
		}[]
	>([])

	const d = useRef(new Debounce())

	useEffect(() => {
		d.current.increase(() => {
			searchResult()
		}, 700)
	}, [searchKeyword])

	const searchResult = () => {
		// console.log('searchKeyword', searchKeyword)

		const k = searchKeyword.trim()

		if (!k) {
			setResult([])
			return
		}

		const r = [] as typeof result

		notes.list.forEach((note) => {
			const noteMatch = [
				...(note?.name || '').matchAll(new RegExp(k, 'ig')),
			]?.[0]

			if (noteMatch?.length) {
				const si = Number(noteMatch?.index)
				r.push({
					note,
					startIndex: si,
					endIndex: si + k.length,
					type: 'Note',
				})
			}

			note.categories?.forEach((cate) => {
				const cateMatch = [
					...(cate.name || '').matchAll(new RegExp(k, 'ig')),
				]?.[0]

				if (cateMatch?.length) {
					const si = Number(noteMatch?.index)
					r.push({
						note,
						category: cate,
						startIndex: si,
						endIndex: si + k.length,
						type: 'Category',
					})
				}
				cate.data?.forEach((page) => {
					const title = page.title || ''
					const content = page.content || ''
					if (title?.indexOf(k) >= 0 || content?.indexOf(k) >= 0) {
						const rItem = {
							note,
							category: cate,
							page,
							type: 'Page',
						} as (typeof result)[0]
						// if (page.title?.indexOf(k) >= 0) {
						// 	console.log('searchKeyword page title', page.title)
						// }
						const htmlReg = /<[^>]+>/gi

						const pageContent = content.replace(htmlReg, '')
						if (pageContent?.indexOf(k) >= 0) {
							const pageContentMatch = [
								...pageContent.matchAll(new RegExp(k, 'ig')),
							]?.[0]

							if (pageContentMatch?.length) {
								const si = Number(pageContentMatch?.index)

								const tsi = si - 20 < 0 ? 0 : si - 20
								const tei = si + k.length + 20

								rItem.pageContent =
									(tsi > 0 ? '...' : '') +
									pageContent.slice(tsi, tei) +
									(tei < pageContent.length - 1 ? '...' : '')
							}
						}
						r.push(rItem)
					}
				})
			})
		})

		console.log('rrrrrrrr', r)
		setResult(r)
	}

	return (
		<SakiAsideModal
			ref={
				bindEvent({
					close: () => {
						dispatch(
							configSlice.actions.setFindInAppModal({
								visible: false,
							})
						)
					},
				}) as any
			}
			vertical='Top'
			horizontal='Center'
			visible={findInAppModal.visible}
			width={config.deviceType === 'Mobile' ? '100%' : 'calc(100% - 20px)'}
			height={
				result.length
					? config.deviceType === 'Mobile'
						? 'calc(100% - 100px)'
						: '570px'
					: ''
			}
			maxWidth={'600px'}
			// height={'100%'}
			border-radius={
				config.deviceType === 'Mobile' && result.length
					? '10px 10px 0 0'
					: '10px'
			}
			box-shadow='0px 1.2px 3.6px rgba(0,0,0,0.1),0px 6.4px 14.4px rgba(0,0,0,0.1)'
			// border='1px solid #eee'
			offset-x='0px'
			offset-y={config.deviceType === 'Mobile' ? '100px' : '40px'}
			mask
			mask-closable
			z-index='1099'
		>
			<div className='find-in-app-modal'>
				<div className='fia-header'>
					<div className='fia-search'>
						<SakiIcon
							color='var(--saki-default-color)'
							width='18px'
							height='18px'
							type='Magnifier'
						></SakiIcon>
						<SakiInput
							onChangevalue={(e) => {
								setSearchKeyword(e.detail)
							}}
							onPressenter={() => {
								searchResult()
							}}
							value={searchKeyword}
							fontSize='18px'
							padding='14px 4px 14px 0px'
							border-radius='0 10px 10px 0'
							placeholder={t('findInApp')}
						></SakiInput>
						{searchKeyword.length ? (
							<SakiButton
								onTap={() => {
									setSearchKeyword('')
									setResult([])
								}}
								margin='0 4px 0 0'
								type='CircleIconGrayHover'
							>
								<SakiIcon
									color='var(--saki-default-color)'
									width='18px'
									height='18px'
									type='Close'
								></SakiIcon>
							</SakiButton>
						) : (
							''
						)}
					</div>
				</div>

				<div
					style={{
						height: result.length
							? config.deviceType === 'Mobile'
								? 'calc(100% - 50px)'
								: '500px'
							: '',
					}}
					className='fia-main scrollBarHover'
				>
					{result.length ? (
						<div className='fia-m-result'>
							{result
								.reduce(
									(rList, v) => {
										if (v.type === 'Note') {
											rList[0].list.push(v)
										}
										if (v.type === 'Category') {
											rList[1].list.push(v)
										}
										if (v.type === 'Page') {
											rList[2].list.push(v)
										}
										return rList
									},
									[
										{
											list: [],
											title: t('notes', {
												ns: 'common',
											}),
										},
										{
											list: [],
											title: t('categories', {
												ns: 'common',
											}),
										},
										{
											list: [],
											title: t('pages', {
												ns: 'common',
											}),
										},
									] as {
										list: typeof result
										title: string
									}[]
								)
								.map((v) => {
									return (
										<>
											{v.list.length ? (
												<SakiTitle
													fontSize='11px'
													fontWeight='300'
													color='#999'
												>
													{v.title}
												</SakiTitle>
											) : (
												''
											)}
											{v.list.map((rItem) => {
												return (
													<div
														ref={
															bindEvent({
																click: () => {
																	const nid = rItem.note?.id || ''
																	const cid = rItem.category?.id || ''
																	const pid = rItem.page?.id || ''
																	dispatch(
																		notesSlice.actions.selectNote({
																			id: nid,
																		})
																	)
																	dispatch(
																		notesSlice.actions.selectCategory({
																			id: cid,
																		})
																	)
																	dispatch(
																		notesSlice.actions.selectPage({
																			id: pid,
																		})
																	)

																	let url = '/'
																	if (config.deviceType === 'Mobile') {
																		url = '/m'
																		if (nid) {
																			url = Query('/m/n', {
																				nid,
																			})
																			if (cid) {
																				url = Query('/m/c', {
																					nid,
																					cid,
																				})
																				if (pid) {
																					url = Query('/m/p', {
																						nid,
																						cid,
																						pid,
																					})
																				}
																			}
																		}
																	} else {
																		url = Query('/', {
																			nid,
																			cid,
																			pid,
																		})
																	}
																	history?.(url, {
																		replace: true,
																	})

																	dispatch(
																		configSlice.actions.setFindInAppModal({
																			visible: false,
																		})
																	)
																},
															}) as any
														}
														className={'fia-r-item ' + rItem.type}
													>
														<span
															className='fia-r-i-name'
															dangerouslySetInnerHTML={{
																__html:
																	(
																		(rItem.type === 'Note'
																			? rItem.note?.name
																			: rItem.type === 'Category'
																			? rItem.category?.name
																			: rItem.page?.title) || ''
																	).replace(
																		new RegExp(
																			'(' + searchKeyword.trim() + ')',
																			'ig'
																		),
																		`<span class="highlight">$1</span>`
																	) || '',
															}}
														></span>
														{rItem.pageContent ? (
															<span
																className='fia-r-i-content'
																dangerouslySetInnerHTML={{
																	__html:
																		rItem.pageContent?.replace(
																			new RegExp(
																				'(' + searchKeyword.trim() + ')',
																				'ig'
																			),
																			`<span class="highlight">$1</span>`
																		) || '',
																}}
															></span>
														) : (
															''
														)}
														{rItem.type !== 'Note' ? (
															<div className='fia-r-i-bottom'>
																{rItem.category?.id ? (
																	<>
																		<span>{rItem.note?.name}</span>
																	</>
																) : (
																	''
																)}
																{rItem.page?.id ? (
																	<>
																		<saki-icon
																			width='12px'
																			height='12px'
																			color='#999'
																			type='Right'
																			margin='0 4px'
																		></saki-icon>
																		<span>{rItem.category?.name}</span>{' '}
																		<saki-icon
																			width='12px'
																			height='12px'
																			color='#999'
																			type='Right'
																			margin='0 4px'
																		></saki-icon>
																		<span>
																			{rItem.page?.type === 'TodoList'
																				? t('notePage', {
																						ns: 'common',
																				  })
																				: t('todoListPage', {
																						ns: 'common',
																				  })}
																		</span>
																	</>
																) : (
																	''
																)}
															</div>
														) : (
															''
														)}
													</div>
												)
											})}
										</>
									)
								})}
						</div>
					) : (
						<div className='fia-m-none'>{t('noResultsFound')}</div>
					)}
				</div>
			</div>
		</SakiAsideModal>
	)
}
export default FindInAppModal
